import { css } from '@emotion/react'
import { SFaqContactUs } from './ContactLead.styled'
import { Icon } from 'components/icon'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'

export function ContactLead(props: { className?: string }) {
  const { t } = useTranslation('security')

  return (
    <SFaqContactUs className={props.className}>
      <Text
        css={css`
          line-height: 1.4em;
        `}
      >
        {t('security.contact_button_desc')}
        <br />
        <Link
          href="https://goodtrust.freshdesk.com/support/home"
          passHref
          legacyBehavior
          target="_blank"
        >
          <strong
            css={css`
              cursor: pointer;
              color: var(--c-blue500);
              display: flex;
              align-items: center;
            `}
          >
            {t('security.contact_button_action')} <Icon name="ArrowLeft" />
          </strong>
        </Link>
      </Text>
    </SFaqContactUs>
  )
}
